export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";